<div [id]="'AT_tableFilters'" class="icon" [matTooltip]="expandablePanel?.opened ? hideFiltersLabel : showFiltersLabel" (click)="toggle()">
  <fa-icon [icon]="faFilter" size="lg"></fa-icon>
</div>
